import { render } from "./VUEIframe.vue?vue&type=template&id=b1d8c608"
import script from "./VUEIframe.vue?vue&type=script&lang=js"
export * from "./VUEIframe.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__